import { Button, CircularProgress } from "@mui/material";
import { useRouteResponse, useSelectedRouteIndex } from "../../../stores/RouteStore";
import GetAppIcon from "@mui/icons-material/GetApp"
import { SourceReferenceSystem } from "../../../services/RuteplanAPI";
import { useRouteSettings } from "../../../stores/RouteSettingsStore";
import { GetRoute, SingleRouteResponse } from "../../../services/RoutingAdapter";
import { useBarrierPoints, useFromAddress, useToAddress, useViaPoints } from "../../../stores/RouteLocationStore";
import { useState } from "react";
import { useUserNotificationActions } from "../../../stores/UserNotificationStore";
import { useEnvironmentName, useEnvironmentSetting } from "../../../stores/EnvironmenSettingStore";

export interface IRouteDownloadButtonProps {
    routeName: string;
    fileName: string;
    coordinateSystem: SourceReferenceSystem;
}

function createFile(route: SingleRouteResponse, fileName: string) {
    const blob = new Blob([JSON.stringify(route)], {type: "application/json"});
    const elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = fileName + ".json";        
    document.body.appendChild(elem);
    elem.click();        
    document.body.removeChild(elem);        
}

export function RouteDownloadButton(props: IRouteDownloadButtonProps) {
    const [isLoadingRoute, setIsLoadingRoute] = useState<boolean>(false);
    const setFeedbackMessage = useUserNotificationActions().setFeedbackMessage;
    
    const {routeName, fileName, coordinateSystem} = props;
    const routeResponse = useRouteResponse();
    const selectedRouteIndex = useSelectedRouteIndex();
    const routeSettings = useRouteSettings();
    const fromAddress = useFromAddress();
    const toAddress = useToAddress();
    const viaPoints = useViaPoints();
    const barrierPoints = useBarrierPoints();
    const environmentName = useEnvironmentName();
    
    const handleDownload = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {

        event.stopPropagation();

        if (!routeResponse) {
            return
        }; 

        if (coordinateSystem === SourceReferenceSystem.EPSG_25833) {
            setIsLoadingRoute(true);
            const settings = {...routeSettings}
            settings.outputSrs = SourceReferenceSystem.EPSG_25833;
            GetRoute(settings, fromAddress!, toAddress!, viaPoints, barrierPoints, environmentName).then((data) => {
                setIsLoadingRoute(false);
                const route = data.routes.find((route) => route.routeName === routeName);
                if (route) {
                    createFile(route, fileName);
                    return;
                }
            }).catch((error) => {
                setIsLoadingRoute(false);
                setFeedbackMessage({message: "Kunne ikke laste ned rute: " + error, severity: "error"});
            });
        }
        else {
            createFile(routeResponse.routes[selectedRouteIndex], fileName);  
        }
    }

    return (    
        <>
            
            {routeResponse &&
                <Button onClick={(event)=>{handleDownload(event)}} style={{marginTop: "10px"}} startIcon={<GetAppIcon/>}>Last ned rute</Button>
                                
            }
            {isLoadingRoute &&
                <CircularProgress />
            }        
        </>
    )
}